import { Component } from '@angular/core';
import { GenericCrudComponent } from '../../../../../shared/components/generic-crud/generic-crud.component';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../../models/GenericCRUD/GenericTable';
import { GenericCRUD } from '../../../../../models/GenericCRUD/GenericCRUD';
import { Filter } from '../../../../../models/GenericCRUD/Filter';
import { Paginator } from '../../../../../models/Paginator';
import { EmailLog } from '../../../../../models/Email';

@Component({
  selector: 'app-email-history',
  standalone: true,
  imports: [GenericCrudComponent],
  templateUrl: './email-history.component.html',
  styleUrl: './email-history.component.css',
})
export class EmailHistoryComponent {
  tableColumns: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Asunto', active: true, type: 'text', key: 'subject', sort: true },
    { name: 'Tipo', active: true, type: 'badge', key: 'send_type', sort: true,
      labelMap: { 'individual': 'Individual', 'bulk': 'Masivo' },
      colorMap: { 'individual': 'info', 'bulk': 'primary' }
    },
    { name: 'Estado', active: true, type: 'badge', key: 'status', sort: true,
      labelMap: {
        'queued': 'En cola',
        'sent': 'Enviado',
        'failed': 'Fallido',
        'partially_failed': 'Parcialmente fallido'
      },
      colorMap: {
        'queued': 'warning',
        'sent': 'success',
        'failed': 'danger',
        'partially_failed': 'warning'
      }
    },
    { name: 'Enviados', active: true, type: 'text', key: 'sent_count', sort: true },
    { name: 'Fallidos', active: true, type: 'text', key: 'failed_count', sort: true },
    { name: 'Fecha Envío', active: true, type: 'date', key: 'sent_at', sort: true, format: 'dd/MM/yyyy HH:mm' },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy HH:mm:ss' },
  ];

  tableActions: GenericTableAction[] = [
    {
      name: 'Reintentar',
      key: 'retry',
      method: 'POST',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-warning" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747" /><path d="M20 4v5h-5" /></svg>',
      confirmation: true,
      questionText: '¿Desea reintentar el envío de este email?',
      actionSlug: '/email/retry/{{id}}',
      showIf: (item: any) => ['failed', 'partially_failed'].includes(item.status),
    }
  ];

  table: GenericTable<Paginator<EmailLog>> = {
    columns: this.tableColumns,
    items: [],
    type: 'generic',
    loadItemsSlug: '/email/history',
    paginate: true,
    name: 'historial de emails',
    actions: this.tableActions,
    details: true,
    detailsSlug: '/dashboard/email/show/{{id}}'
  };

  filters: Filter[] = [
    { type: 'search', key: 'subject', operator: 'like', placeholder: 'Buscar por asunto' },
    {
      type: 'select',
      key: 'status',
      operator: '=',
      placeholder: 'Filtrar por estado',
      options: [
        { label: 'En cola', value: 'queued' },
        { label: 'Enviado', value: 'sent' },
        { label: 'Fallido', value: 'failed' },
        { label: 'Parcialmente fallido', value: 'partially_failed' },
      ]
    },
    {
      type: 'select',
      key: 'send_type',
      operator: '=',
      placeholder: 'Filtrar por tipo',
      options: [
        { label: 'Individual', value: 'individual' },
        { label: 'Masivo', value: 'bulk' },
      ]
    }
  ];

  genericCRUD: GenericCRUD<Paginator<EmailLog>> = {
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: false
  };
}
